export default __webpack_public_path__ + "static/media/copy-category-icon.3941c24a.svg";